import { useLazyQuery } from '@apollo/client';
import { observer } from 'mobx-react-lite';
import React, { useState, useId } from 'react';

import { Icon, IconStation, IconStationSolid } from '@flixbus/honeycomb-icons-react';
import {
	LegacyAutocomplete as Autocomplete,
	LegacyAutocompleteInput as AutocompleteInput,
	LegacyAutocompleteOptions as AutocompleteOptions,
} from '@flixbus/honeycomb-react';

import { rideFilterStore } from 'pages/RideListPage/components/RideFilters/RideFilterStore';

import { buildLocationConfig, mapCitiesToOptions } from './buildLocationConfig';
import { SEARCH_CITY_BY_NAME } from './gql';
import { LOCATIONS_FILTER_TEXT } from './texts';

const LocationSearch = observer(
	({ label = LOCATIONS_FILTER_TEXT.defaultLabel, isArrival = false }) => {
		const rawId = useId();
		const id = rawId.replace(/:/g, '');
		const [cities, setCities] = useState([]);
		const [inputValue, setInputValue] = useState('');

		const [getCitiesByName, { loading }] = useLazyQuery(SEARCH_CITY_BY_NAME, {
			fetchPolicy: 'no-cache',
			onCompleted: (data) => {
				setCities(mapCitiesToOptions(data?.searchCitiesByName));
			},
		});

		const { placeholder, filterType } = buildLocationConfig(isArrival);

		const onDebounce = (e) => {
			if (!e.target.value) return;
			getCitiesByName({ variables: { cityName: e.target.value } });
		};

		const onSelect = (item) => {
			rideFilterStore.addFilter({ value: item, type: filterType });
			setCities([]);
			setInputValue('');
		};

		const checkEmpty = (e) => {
			if (e.target.value === '') {
				setCities([]);
			}
			setInputValue(e.target.value);
		};

		return (
			<Autocomplete
				onDebounce={(e) => onDebounce(e)}
				onSelect={(item) => {
					onSelect(item);
				}}
				onChange={(e) => {
					checkEmpty(e);
				}}
				options={cities}
				value={''}
				label={label}
			>
				<AutocompleteInput
					id={`autocomplete-city-${id}`}
					placeholder={placeholder}
					label={label}
					loading={loading}
					iconLeft={
						isArrival ? <Icon InlineIcon={IconStationSolid} /> : <Icon InlineIcon={IconStation} />
					}
					type="search"
					value={inputValue}
				/>
				<AutocompleteOptions label={LOCATIONS_FILTER_TEXT.optionsLabel} optionsToDisplay={5} />
			</Autocomplete>
		);
	}
);

export default LocationSearch;
